<template>
  <section class="page-map">
    <Map id="page-map-viz"/>
    <MapSidePanel />    
  </section>
</template>

<script>
import Map from '@/components/views/map/Map';
import MapSidePanel from '@/components/views/map/MapSidePanel';

import { mapGetters } from 'vuex';

export default {
  name: 'MapPage',
  components: {
    Map,
    MapSidePanel,
  },
  data() {
    return {
      selectedEl: null,
    };
  },
  computed: {
     ...mapGetters('contentPanel', ['panelState']), 
  },
  methods: {
    updateSelected(e) {
      this.selectedEl = e;
    },
    resetMap() {
      this.$refs.mapComponent.resetMap();
    },   
    showPanel() {
      this.$store.dispatch('contentPanel/updatePanelState', '--is-open');
    }
  },
}
</script>

<style scoped lang="scss">
#page-map-viz {
  position: fixed;
  top: 0;
  height: calc(var(--vh, 1vh) * 100 );
  left: 0;
  right: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100 );
}
</style>